class AddToCartBtn {
  constructor() {
    this.waitForContainer();
  }

  isSmallContainer(container) {
    return container.offsetWidth < 1024;
  }

  addContainerClassNames(container) {
    // 1. container
    container.classList.add('cs-vs__container');

    // 2. main title
    const [titleContainer, sliderContainer] = container.querySelectorAll('div');
    titleContainer.classList.add('cs-vs__title');

    // 3. slider
    // 3.1. slider container
    sliderContainer.classList.add('cs-vs__slider-container');

    // 3.2. slider
    const slider = sliderContainer.querySelector('div');
    slider.classList.add('cs-vs__slider');
  }

    waitForContainer() {
        this.handled = new WeakSet();

        const process = (containers) => {
            containers.forEach((container) => {
                if (this.handled.has(container)) return;
                this.handled.add(container);
                this.addContainerClassNames(container);
                this.waitForButtons(container);
            });
        };

        process(document.querySelectorAll(".go3273843906"));

        const observer = new MutationObserver(() => {
            process(document.querySelectorAll(".go3273843906"));
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

  waitForButtons(container) {
    if (!container) return;

    const existing = container.querySelectorAll(".vsly-product-atc-section");
    if (existing.length > 0) {
      if (this.isSmallContainer(container)) {
        this.updateAddToCartContent(existing);
      }
      return;
    }

    const observer = new MutationObserver(() => {
      const btns = container.querySelectorAll(".vsly-product-atc-section");
      if (btns.length > 0) {
        observer.disconnect();
        if (this.isSmallContainer(container)) {
          this.updateAddToCartContent(btns);
        }
      }
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  updateAddToCartContent(btns) {
    const markup = `
      <span class="visually-hidden">Add to cart</span>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="M12.12 20.44H5.6V9.56h12.8v3.73c.06.4.4.69.8.7.44 0 .8-.35.8-.8v-4.5a.792.792 0 0 0-.8-.69H17V6.5C16.9 4 14.7 2 12 2S7 4.09 7 6.67V8H4.71c-.4.04-.71.37-.71.78v12.53a.8.8 0 0 0 .8.69h7.43c.38-.06.67-.39.67-.78 0-.43-.35-.78-.78-.78ZM8.66 6.67c0-1.72 1.49-3.11 3.33-3.11s3.33 1.39 3.33 3.11V8H8.65V6.67Z"></path><path d="M20 17.25h-2.4v-2.5a.817.817 0 0 0-.8-.7c-.44 0-.8.36-.8.8v2.4h-2.5c-.4.06-.7.4-.7.8 0 .44.36.8.8.8H16v2.5c.06.4.4.7.8.7.44 0 .8-.36.8-.8v-2.4h2.5c.4-.06.69-.4.7-.8 0-.44-.35-.8-.8-.8Z"></path></svg>
    `;

    btns.forEach((btn) => {
      const span = btn.querySelector("span");
      if (span) span.innerHTML = markup;
    });
  }
}

new AddToCartBtn();